import { SliderFilesResource } from 'app/resources/homepage/SliderFilesResource';

export class SliderFilesListResource {
    list: SliderFilesResource;
}